import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SurveyAnswerService } from '../../public-api';
import { Options, Question, Survey } from '../shared/model-service';
import { PopupService } from '../shared/popup-service';
@Component({
  selector: 'app-year',
  templateUrl: './year.component.html',
  styleUrls: ['./year.component.css']
})
export class YearComponent implements OnInit {
  panelOpenState = true;
  @Input() Question: Question;
  @Input() SurveyBase: Survey
  years: number[] = [];
  show: boolean = false;
  selectedYear = [];
  questiondsIdLinks: number[] = [];
  questions: Question[] = [];
  result: Question;
  option: Options;
  timer: any;
  popupService: PopupService
  constructor(private dialog: MatDialog, private surveyService: SurveyAnswerService) { }

  ngOnInit(): void {
    this.popupService = new PopupService(this.dialog);
    this.option = this.Question.options[0];

    var startYear = 1900;
    var endYear = new Date().getFullYear();
    for (let i = endYear; i > startYear; i--) {
      this.years.push(i);
    }

    if (this.option.result) {
      this.treatEditSurvey(this.SurveyBase);
    }
  }

  onNgModelChange() {

    if (this.timer != null) {
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      this.panelOpenState = false;
    }, 5000);


    this.show = true
    if (this.option.result) {
      this.questiondsIdLinks = [];
      this.questions = [];
      //this.Question.result = this.selectedYear.toString();
      let links = this.Question?.options[0]?.links;
      if (links != []) {
        links.forEach(link => {
          this.questiondsIdLinks.push(link.questionDestinationId);
          /** Open Popup */
          if (link.popupDestinationId != null) {
            this.popupService.openPopupDialog(link.popupDestinationId, this.SurveyBase);
          }

          /**Open Tip*/
          if (link.tipDestinationTipId != null) {
            this.popupService.openTipDialog(link.tipDestinationTipId);
          }
        });

        this.questiondsIdLinks.forEach(link => {
          this.result = this.SurveyBase.questions.find(x => x.id == link);
          if (this.result != null) {
            this.questions.push(this.result);
          }
        })
      }
    }
  }


  treatEditSurvey(survey) {
    this.panelOpenState = false;
    this.show = true;
    this.option.links.forEach(element => {
      this.questiondsIdLinks.push(element.questionDestinationId);
    });

    this.questiondsIdLinks.forEach(element => {
      this.result = this.SurveyBase.questions.find(x => x.id == element);
      if (this.result ) {
        this.questions.push(this.result);
      }
    })
  }
}
